<!--
 * @Author: RYL
 * @Description: 用于GPS模块，使用图层与首页保持一致
 * @Date: 2020-11-27 14:46:47
 * @LastEditTime: 2020-12-10 18:20:21
-->
<template>
  <div>
    <div id="map"></div>
  </div>
</template>
<script>
import L from 'leaflet'
import { GetLan, SetMapType, GetMapType } from "@/localStorage/localStorage";
import { coordtransform } from '@/utils/mapUtils'
export default {
  props: ['list'],
  data() {
    return {
      map: null,
      marker: null
    }
  },
  mounted() {
    this.initMap()
  },
  watch: {
    'list.deviceLatitude': {
      handler: function (oldV, newV) {
        if (oldV != '') {
          console.log(this.map);
        }
        this.setMarker()
      }
    },
    'list.deviceLongitude': {
      handler: function (oldV, newV) {
        if (oldV != '') {
          console.log(this.map);
        }
        this.setMarker()
      }
    }
  },
  methods: {
    // 初始化地图
    initMap() {
      this.map = null
      let laguage = GetLan()
      if (laguage === 'zh-CN' || laguage == null) {
        this.mapLaguage = 'zh_cn'
      } else {
        this.mapLaguage = 'en'
      }
      // 高德地图图层
      let tiles = L.tileLayer(`http://webrd0{s}.is.autonavi.com/appmaptile?lang=${this.mapLaguage}&size=1&scale=1&style=8&x={x}&y={y}&z={z}`, {
        attribution: '&copy; 高德地图',
        maxZoom: 15,
        minZoom: 3,
        subdomains: "1234"
      })
      // google地图
      let gooleTiles = L.tileLayer(`http://www.google.cn/maps/vt?lyrs=m@189&hl=${this.mapLaguage}&gl=cn&x={x}&y={y}&z={z}`, {
        attribution: '&copy; 谷歌地图',
        maxZoom: 15,
        minZoom: 3,
        subdomains: "1234"
      })
      // 添加openstreetmap图块层
      // let openTiles = L.tileLayer("http://"+location.hostname+'/{z}/{x}/{y}.png', {
      let openTiles = L.tileLayer("https://chilinkcloud.com/osm/tile/{z}/{x}/{y}.png", {
        maxZoom: 18,
        minZoom: 3,
        // openstreetmap归因
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      })
      let mapType = GetMapType()
      let customerTiles = tiles
      if (mapType === 'Google地图' || mapType === 'Google Map') {
        customerTiles = gooleTiles
      } else if (mapType === 'openStreetMap') {
        customerTiles = openTiles
      } else {
        customerTiles = openTiles
      }
      let center = null
      let zoom = 3
      if (this.list.deviceLatitude && this.list.deviceLongitude) {
        center = [this.list.deviceLatitude, this.list.deviceLongitude]
        zoom = 8
      } else {
        center = [50.5, 30.51]
        zoom = 3
      }
      this.map = L.map('map', {
        center: center,
        zoom: zoom, // 缩放级别
        layers: [customerTiles], //添加图层到地图上
        zoomControl: false
      })
      this.setMarker()
    },
    // 设置maker
    setMarker() {
      let mapType = GetMapType()
      if (this.marker) {
        this.map.removeLayer(this.marker)
      }
      let content = `${this.list.deviceSn}${this.list.deviceName ? `（${this.list.deviceName}）` : ''}`
      if (this.list.deviceLatitude && this.list.deviceLongitude) {
        let mypoint = null
        if (mapType === 'openStreetMap') {
          //版本过滤，v2.4以上的版本，gps基础数据是WGS-84，其它为GCJ-02
          if (this.list.deviceSoftwareVer > "v2.3") {
            mypoint = [this.list.deviceLatitude, this.list.deviceLongitude]
          } else {
            mypoint = coordtransform.gcj02towgs84(this.list.deviceLatitude, this.list.deviceLongitude)
          }
        } else {
          //版本过滤，v2.4e及以上的版本，gps基础数据是WGS-84，其它为GCJ-02
          if (this.list.deviceSoftwareVer > "v2.3") {
            mypoint = coordtransform.wgs84togcj02(this.list.deviceLatitude, this.list.deviceLongitude)
          } else {
            mypoint = [this.list.deviceLatitude, this.list.deviceLongitude]
          }
        }
        this.marker = L.marker(mypoint)
        // this.marker = L.marker([this.list.deviceLatitude, this.list.deviceLongitude])
        this.marker.addTo(this.map).bindPopup(content).openPopup()
      }
      // 监听地图的点击
      this.map.on('click', (event) => {
        // 允许修改时才能移动坐标
        if (this.list.deviceLocType != 2) { // 设备不支持定位服务
          if (this.marker) { // 如果原来存在标记点需要先把原来的标记点删除
            this.map.removeLayer(this.marker)
          }
          this.marker = L.marker([event.latlng.lat, event.latlng.lng])
          this.marker.addTo(this.map).bindPopup(content).openPopup()
          this.$emit('updateLatLng', event.latlng.lat, event.latlng.lng)
        }
      })
    },
    // 获取marker
    getMarker() {
      return this.marker
    },
    // 重置marker
    ResetLatLng() {
      this.map.removeLayer(this.marker)
      let content = `${this.list.deviceSn}${this.list.deviceName ? `（${this.list.deviceName}）` : ''}`
      let mapType = GetMapType()
      let mypoint = null
      if (mapType === 'openStreetMap') {
        mypoint = coordtransform.gcj02towgs84(this.list.deviceLatitude, this.list.deviceLongitude)
      } else {
        mypoint = [this.list.deviceLatitude, this.list.deviceLongitude]
      }
      this.marker = L.marker(mypoint)
      this.marker.addTo(this.map).bindPopup(content).openPopup()
    },
    remove() {
      if (this.map) {
        this.map.remove();
      }
    },

  }
}
</script>
<style scoped>
#map {
  height: 50vh;
  width: 100%;
}
</style>
